<template>
  <div>
    <el-dialog title="值班表" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <div class="ctime">闯关时间：{{dateTime}}<el-button size="mini" type="primary" round @click="handleScheduling">排班</el-button></div>
      <el-calendar v-model="value">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{date, data}">
          <!-- 这里加了周六周天的判断(用于添加不同样式) -->
          <!-- <div :class="(date.getDay()==6 || date.getDay()==0)?'weeked' :'notweeked'">{{ data.day.split('-').slice(2).join('-') }}</div> -->
          <div>{{ data.day.split('-').slice(2).join('-') }}</div>
          <!-- 数组循环 -->
          <div class="cell" v-for="(item,index) in tableData" :key="index">
            <!-- 加数据 -->
            <div v-if="data.day == item.dutyTime" class="rota-item">
              <p>{{item.realName}}（客服）</p>
              <p>{{item.mobile}}</p>
              <p class="it3" @click="handleSwitch(item)"><i class="el-icon-edit"></i>调班</p>
            </div>
          </div>
        </template>
      </el-calendar>
    </el-dialog>
    <scheduling-vue ref="schedulingVue" :serviceOptions="serviceOptions" @created="getDutyTeacher()" />
    <switch-vue ref="switchVue" :serviceOptions="serviceOptions" @created="getDutyTeacher()" />
  </div>
</template>

<script>
import courseSubjectBarrierDutyTeacher from '@/api/course/courseSubjectBarrierDutyTeacher'
import custServiceStaffApi from '@/api/customer/custServiceStaff'
import schedulingVue from './scheduling.vue'
import switchVue from './switch.vue'
export default {
  components: { schedulingVue, switchVue },
  data() {
    return {
      form: null,
      list: [],
      formVisible: false,
      value: new Date(),
      // tableData: [
      //   { day: '2024-11-05', isStatus1: 0, isStatus2: 1 },
      //   { day: '2024-11-10', isStatus1: 4, isStatus2: 3 },
      //   { day: '2024-11-11', isStatus1: 2, isStatus2: 1 },
      //   { day: '2024-11-12', isStatus1: 3, isStatus2: 2 },
      //   { day: '2024-11-13', isStatus1: 1, isStatus2: 4 },
      //   { day: '2024-11-14', isStatus1: 0, isStatus2: 0 },
      // ],
      tableData: [],
      dateTime: '',
      rowItem: null,
      serviceOptions: []
    }
  },
  created() {
    this.getService()
  },
  methods: {
    getService() {
      custServiceStaffApi.fetchForList({ status: 10 }).then(res => {
        this.serviceOptions = res.data
      })
    },
    handleRota(row) {
      if (row.startTime && row.endTime) {
        this.dateTime = `${row.startTime.substr(0, 10)}-${row.endTime.substr(0, 10)}`
      }
      this.rowItem = row
      this.getDutyTeacher()
    },
    getDutyTeacher() {
      courseSubjectBarrierDutyTeacher.fetchList({ barrierId: this.rowItem.id }).then(res => {
        this.tableData = res.data;
        this.formVisible = true
      })
    },
    handleScheduling() {
      this.$refs.schedulingVue.handleScheduling(this.rowItem)
    },
    handleSwitch(row) {
      this.$refs.switchVue.handleSwitch(row)
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 20px;
}
.ctime {
  font-size: 20px;
  button {
    margin-left: 10px;
  }
}
.rota-item {
  text-align: center;
  p {
    font-size: 13px;
    margin: 0;
    padding-top: 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.it3 {
      cursor: pointer;
      text-align: right;
      i {
        margin-right: 3px;
      }
    }
  }
}
</style>
